import { useTheme } from 'app/shopify';
import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { WhiteLabel } from 'app/types/white-labels';
import { isWhiteLabel } from 'app/utils/helpers';
import { ChatNotificationSection } from './chat-notification-section';
import { ConciergerieNotificationSection } from './conciergerie-notification-section';
import { NeedNotificationSection } from './need-notification-section';
import type { NeedToggle, NotificationToggle } from './notification-toggle.types';
import { OptionalNotificationSection } from './optional-notification-section';

export const NotificationPreferencesView = ({
  interestAlertsEnabled,
  isLargeUI,
  pageTitle,
  togglesForConciergerie,
  togglesForInterests,
  togglesForNeed,
  togglesForUnseenChannel,
  togglesForUrgentOffers,
  usesSectorNeedSources,
}: {
  interestAlertsEnabled: boolean;
  isLargeUI: boolean;
  pageTitle: string;
  togglesForConciergerie: NotificationToggle[];
  togglesForInterests: NotificationToggle[];
  togglesForNeed: NeedToggle[];
  togglesForUnseenChannel: NotificationToggle[];
  togglesForUrgentOffers: NotificationToggle[];
  usesSectorNeedSources: boolean;
}) => {
  const theme = useTheme();
  return (
    <Column style={{ gap: theme.spacing['spacing.general.x6'] }}>
      {isLargeUI ? (
        <Text fontWeight="700" textAlign="left" variant="bodyLarge">
          {pageTitle}
        </Text>
      ) : null}
      <ChatNotificationSection toggles={togglesForUnseenChannel} {...{ isLargeUI }} />
      {/* Hidden: weekly new-offers communication (push + email). Uncomment to re-enable.
        <Separator onlyWidth />
        <Text fontWeight="700" textAlign={isLargeUI ? 'left' : 'center'} variant={isLargeUI ? 'bodyBase' : 'bodyLarge'}>
         {t('weeklyOffersTitle')}
        </Text>
        <Text variant="bodyBase">{t('weeklyOffersHelp')}</Text>
        <Column gap="spacing.general.x4">
         {togglesForWeeklyOffers.map(({ label, value, onValueChange }) => (
           <Row
             alignItems="center"
             key={label}
             style={{
               paddingHorizontal: theme.spacing['spacing.general.x4'],
               paddingVertical: theme.spacing['spacing.general.x2'],
               backgroundColor: theme.colors['surface.tertiary-neutral'],
               borderRadius: theme.borderRadii['radius.sm'],
             }}
           >
             <Text flex={1} fontWeight="700" variant="bodyBase">
               {label}
             </Text>
             <Switch onValueChange={onValueChange} value={value} />
           </Row>
         ))}
        </Column>
        */}
      <ConciergerieNotificationSection toggles={togglesForConciergerie} {...{ isLargeUI }} />
      <OptionalNotificationSection
        helpKey="urgentOffersHelp"
        {...{ isLargeUI }}
        titleKey="urgentOffersTitle"
        toggles={togglesForUrgentOffers}
        visible={isWhiteLabel(WhiteLabel.HauteGaspesie)}
      />
      <OptionalNotificationSection
        helpKey="interestAlertsHelp"
        {...{ isLargeUI }}
        titleKey="interestAlertsTitle"
        toggles={togglesForInterests}
        visible={interestAlertsEnabled}
      />
      <NeedNotificationSection toggles={togglesForNeed} {...{ isLargeUI, usesSectorNeedSources }} />
    </Column>
  );
};
